import Resource from '@/api/resources/Resource'

class ComplementaryInformationService extends Resource {
    async findById(labId, casId, complementaryId) {
        return this.axios.get(`/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}/information`)
            .then(response => response.data)
    }

    async updateDescription(labId, casId, complementaryId, description) {
        return this.axios.put(`/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}/information`, description)
            .then(response => response.data)
    }

    async updateDescriptionAndSolveCodificationsChange(laboratoryId, caseId, complementaryId, description, replaceInsteadOfAdd) {
        const params = { replaceInsteadOfAdd }
        const response = await this.axios.put(`/laboratories/${laboratoryId}/cases/${caseId}/complementaries/${complementaryId}/macro/solveCodificationsChange`, description, { params })
        return response.data
    }
}

export default new ComplementaryInformationService()
